var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-container",class:_vm.isPc ? 'pc': 'mobile'},[_c('div',{class:_vm.isPc ? 'input-container pc': 'input-container mobile'},[_c('el-input',{staticClass:"input",attrs:{"disabled":_vm.isDisabled},model:{value:(_vm.internalValue),callback:function ($$v) {_vm.internalValue=$$v},expression:"internalValue"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }